import './cart-product-added.scss';

export default () => {

}